import {
  ACCOMMODATION_PLACEHOLDER_IMAGE,
  ACCOMMODATION_PLACEHOLDER_IMAGE_DESKTOP,
} from "@/constants/images";

/** Cover photo URL, or the branded placeholder when none is available. */
export function getAccommodationImageSrc(
  fileKey?: string | null,
  variant: "default" | "desktop" = "default",
): string {
  const trimmed = fileKey?.trim();
  if (!trimmed || trimmed === "-") {
    return variant === "desktop"
      ? ACCOMMODATION_PLACEHOLDER_IMAGE_DESKTOP
      : ACCOMMODATION_PLACEHOLDER_IMAGE;
  }
  return trimmed;
}
